import { registerPlugin, WebPlugin } from '@capacitor/core';

export interface DownloadUrlOptions {
  url: string;
}

export interface SettingOptions {
  type: string;
}

export interface KioskModePlugin {
    hasKioskMode():  Promise<{ support: boolean }>;
    openSetting(options: SettingOptions): Promise<void>;
    exitKioskMode(): Promise<void>;
    getVersionCode():  Promise<{ versionCode: number }>;
    updateVersion(options: DownloadUrlOptions): Promise<void>;
}

export const KioskMode = registerPlugin<KioskModePlugin>('KioskMode');

export class KioskModeWeb extends WebPlugin implements KioskModePlugin {
  hasKioskMode():  Promise<{ support: boolean }> {
    throw new Error('KioskMode is not available on web.');
  }
  openSetting(): Promise<void> {
    throw new Error('KioskMode is not available on web.');
  }

  exitKioskMode(): Promise<void> {
    throw new Error('KioskMode is not available on web.');
  }

  getVersionCode():  Promise<{ versionCode: number }> {
    throw new Error('KioskMode is not available on web.');
  }
  
  updateVersion(): Promise<void> {
    throw new Error('LiveVideo is not available on web.');
  }
}
